export default "__VITE_ASSET__Cy7o2obl__"